import { BrowserRouter, Routes, Route } from "react-router-dom"
import { SignedIn, SignedOut, RedirectToSignIn, ClerkLoaded } from '@clerk/clerk-react';
import { VercelThemeProvider } from "./components/ui/theme-provider"
import AdminLayout from "./components/mvpblocks/AdminLayout"
import { HomePage } from "./pages/HomePage"
import ResourcesPage from "./pages/ResourcesPage"
import MonitoringPage from "./pages/MonitoringPage"
import SecurityPage from "./pages/SecurityPage"
import CostsPage from "./pages/CostsPage"
import AutomationPage from "./pages/AutomationPage"
import WorkflowsPage from "./pages/WorkflowsPage"
import SettingsPage from "./pages/SettingsPage"
import VercelThemeShowcase from "./components/ui/vercel-theme-showcase"
import SignUpPage from "./pages/SignUpPage";
import SignInPage from "./pages/SignInPage";

function App() {
  return (
    <VercelThemeProvider
      defaultTheme="dark"
      defaultAccent="blue"
      storageKey="openconsole-theme"
    >
      <BrowserRouter>
        <ClerkLoaded>
          <Routes>
            {/* Clerk Auth Routes */}
            <Route path="/sign-in" element={<SignInPage />} />
            <Route path="/sign-up" element={<SignUpPage />} />
            {/* Protected App Routes */}
            <Route path="/" element={
              <SignedIn>
                <AdminLayout />
              </SignedIn>
            }>
              <Route index element={<HomePage />} />
              <Route path="resources" element={<ResourcesPage />} />
              <Route path="monitoring" element={<MonitoringPage />} />
              <Route path="security" element={<SecurityPage />} />
              <Route path="costs" element={<CostsPage />} />
              <Route path="automation" element={<AutomationPage />} />
              <Route path="workflows" element={<WorkflowsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="theme-demo" element={<VercelThemeShowcase />} />
            </Route>
            {/* Redirect all other routes to sign-in if not authenticated */}
            <Route path="*" element={<SignedOut><RedirectToSignIn /></SignedOut>} />
          </Routes>
        </ClerkLoaded>
      </BrowserRouter>
    </VercelThemeProvider>
  )
}

export default App
